export default __webpack_public_path__ + "static/media/interactive.4e987744.svg";